import { Epoc } from "../_models/Epoc";
import { Decimal } from "../_models/Decimal";

export class NumbersUtils {
  public static decimalToNumber(decimal: Decimal): number {
    return Number(decimal);
  }
  public static numberToDecimal(number: number): Decimal {
    return number.toString() as Decimal;
  }
}



// WEBPACK FOOTER //
// ./src/app/_helpers/NumbersUtils.ts